import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_WRITE_ROLES } from '@/features/medication-register/access'
import { FollowUpPage } from '@/features/medication-register/follow-up-page'

const searchSchema = z.object({
  // Which follow-up shape the entry page asked for (R11).
  action: z.enum(['review', 'witness']),
})

/** Following up on a witness is a manager write (X2). */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/$accountId/entries/$entryId/follow-up'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_WRITE_ROLES])
    await requireActiveSubscription()
  },
  validateSearch: searchSchema,
  component: FollowUpPage,
})
